import React,{ useState, useEffect } from "react"
import axios from "axios"
import { useNavigate } from "react-router-dom"
import baseURL from "../Url/Url.jsx"

const Login = () => {
    const [userName, setUserName] = useState("")
    const [password, setPassword] = useState("")
    const [perusahaan, setPerusahaan] = useState("")
    const [selectPerusahaan, setSelectPerusahaan] = useState([])
    const [adminPassword, setAdminPassword] = useState("");
    const [adminMsg, setAdminMsg] = useState("");
    const [msg, setMsg] = useState("")
    const [errorMessage, setErrorMessage] = useState("");
    const [displayLoader, setDisplayLoader] = useState("")
    const [namaPerusahaan, status] = perusahaan.split("|")
    const navigate = useNavigate()

    useEffect(()=>{
        setDisplayLoader("none")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Login
    const login = async(e)=>{
        e.preventDefault()
        try {
            setDisplayLoader("")
            await axios.post(`${baseURL}/loginBE`,{
                perusahaan: namaPerusahaan,
                status: status,
                userName: userName,
                password: password
            })
            navigate("/menu-loading", { replace: true })
        } catch (error) {
            if(error.response){
                setDisplayLoader("none")
                setMsg(error.response.data.msg)
            }
        }
    }

    // Mengambil data perusahaan
    const dataPerusahaan = async () => {
        try {
            setErrorMessage(""); // reset error

            const response = await axios.post(
                `${baseURL}/selectUserByKtpBE`,
                { userName: userName }
            );

            // ❌ jika username tidak ditemukan
            if (!response.data || response.data.length === 0) {
                setSelectPerusahaan([]);
                setErrorMessage("Username tidak ditemukan");
                return;
            }

            // ✅ jika data ada
            setSelectPerusahaan(response.data);

        } catch (error) {
            console.log(error);
            setSelectPerusahaan([]);
            setErrorMessage("Username tidak ditemukan");
        }
    };

    // Halaman
    return (
        <div>
            <div className="loader-page-bg" style={{display:displayLoader}}>
                <div className="loader-page"></div>
            </div>

            {/* Modal */}
            <div className="modal fade" id="staticBackdropPilihPerusahaan" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="btn btn-logout mx-auto px-4 py-1" data-bs-dismiss="modal" aria-label="Tutup">Tutup</button>
                        </div>
                        <div className="modal-body">
                            {!errorMessage && (
                                <h5 className="text-center fw-bold mt-3 mb-4">Silahkan Untuk Pilih Perusahaan</h5>
                            )}
                            <h6 className="text-center text-danger" style={{marginTop:"-10px"}}>{msg}</h6>
                            {errorMessage && (
                                <div className="text-danger fw-semibold text-center my-2">
                                    {errorMessage}
                                </div>
                            )}
                            {!errorMessage && (
                            <div className="row px-4">
                                <div className="col-12 mb-3">
                                    <form onSubmit={login}>
                                        <input type="text" id="userName" className="form-disable" placeholder="Masukan username" value={userName} readOnly required/>
                                        <input type="password" id="password" className="form-disable" placeholder="Masukan password" value={password} readOnly required/>
                                        <select className="form-select form text-center" id="bulan" aria-label="bulan" value={perusahaan} onChange={(e) => setPerusahaan(e.target.value)} required>
                                            <option value="">Pilih Perusahaan</option>
                                            {selectPerusahaan.map((item, index) => (
                                                <option key={index} value={`${item.perusahaan}|${item.status}`}>{item.perusahaan} ({item.status})</option>
                                            ))}
                                        </select>
                                        <button type="submit"className="btn btn-webew-login mt-4">Login</button>
                                    </form>
                                </div>
                            </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {/* Modal Admin */}
            <div className="modal fade"id="staticBackdropAdmin"data-bs-backdrop="static"data-bs-keyboard="false"tabIndex="-1"aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button"className="btn btn-logout mx-auto px-4 py-1"data-bs-dismiss="modal"aria-label="Tutup"onClick={() => {setAdminPassword("");setAdminMsg("");}}>Tutup</button>
                        </div>
                        <div className="modal-body">
                            <h5 className="text-center fw-bold mt-3 mb-4">Masukkan Password Admin</h5>
                            <h6 className="text-center"style={{ marginTop: "-10px", color: "red" }}>{adminMsg}</h6>
                            <div className="row px-4">
                                <div className="col-12 mb-3">
                                    <form onSubmit={(e) => {e.preventDefault();if (adminPassword === "admin123") {navigate("/adm13n");window.location.reload();;} else {setAdminMsg("Password admin salah");}}}>
                                        <input type="password"className="form-control form mb-3"placeholder="Masukkan password admin"value={adminPassword}onChange={(e) => setAdminPassword(e.target.value)}required autoFocus/>
                                        <button type="submit" className="btn btn-webew-login mt-3">Masuk</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Login */}
            <div className="container mb-4" style={{marginTop:"80px"}}>
                <div className="row justify-content-center">
                    <div className="col-11 col-sm-8 col-md-6 col-lg-5 col-xl-4">
                        <div className="box-login">
                            <h4 className="text-center" style={{fontWeight:"700"}}>Mantap Payroll</h4>
                            <h6 style={{textAlign:"center",marginTop:"15px",marginBottom:"-10px",color:"red"}}>{msg}</h6>
                             <form onSubmit={(e) => { 
                                e.preventDefault(); 
                                dataPerusahaan(); 
                            }}>
                                <label htmlFor="userName" className="mx-2"></label>
                                <input type="text" id="userName" className="form-control form mb-2" placeholder="Masukan username" value={userName} onChange={(e) => setUserName(e.target.value)} required autoFocus/>
                                <label htmlFor="password" className="mx-2"></label>
                                <input type="password" id="password" className="form-control form mb-4" placeholder="Masukan password" value={password} onChange={(e) => setPassword(e.target.value)} required/>
                                <button type="submit" className="btn btn-webew-login mt-3 mb-3" data-bs-toggle="modal" data-bs-target="#staticBackdropPilihPerusahaan">Lanjut</button>
                            </form>
                            <button className="btn btn-link mx-auto d-block p-0"data-bs-toggle="modal"data-bs-target="#staticBackdropAdmin"style={{ fontSize: "11pt" }}>Masuk Menu Admin</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login